import React from 'react'
import styled from '@emotion/styled'
import { colors } from 'Constants'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons'

import { Flex } from 'lese'

const SectionHeader = styled.span`
  font-size: 0.8em;
`

const SectionTitle = styled.span`
  font-size: 1.2em;
`

const SectionHeaderHover = styled(SectionHeader)`
  user-select: none;
  cursor: pointer;
  transition-duration: 0.2s background-color;
  :hover {
    background-color: ${colors.background600};
  }
`
const SectionHeaderSort = ({ selected, reversed, children, ...props }) => (
  <SectionHeaderHover {...props}>
    {children}
    {selected && (
      <FontAwesomeIcon
        icon={reversed ? faSortUp : faSortDown}
        style={{ paddingLeft: '8px' }}
      />
    )}
  </SectionHeaderHover>
)

export default ({ header, title }) => (
  <Flex column separation="4px">
    <SectionHeader>{header}</SectionHeader>
    <SectionTitle>{title}</SectionTitle>
  </Flex>
)

export { SectionHeader, SectionHeaderSort, SectionTitle }
